var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_819_4828)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09375 6.52011C9.03906 4.87861 7.65625 3.5625 5.96875 3.5625C4.24219 3.5625 2.84375 4.9345 2.84375 6.625V15.0469C2.84375 16.7381 4.24219 18.1094 5.96875 18.1094H14.5625C16.2891 18.1094 17.6875 16.7374 17.6875 15.0469C17.6875 13.3564 16.2891 11.9844 14.5625 11.9844H12.2734C15.664 8.67381 20.3359 6.625 25.5 6.625C35.8516 6.625 44.25 14.8585 44.25 25C44.25 35.1415 35.8516 43.375 25.5 43.375C15.1484 43.375 6.75 35.1415 6.75 25C6.75 23.3095 5.35156 21.9375 3.625 21.9375C1.89844 21.9375 0.5 23.3095 0.5 25C0.5 38.5217 11.7031 49.5 25.5 49.5C39.2969 49.5 50.5 38.5217 50.5 25C50.5 11.4783 39.2969 0.5 25.5 0.5C19.2266 0.5 13.4844 2.77085 9.09375 6.52011ZM22.375 12.75V25C22.375 25.8123 22.7032 26.591 23.2891 27.1652L28.0234 31.8033C29.2422 32.9985 31.2266 32.9985 32.4453 31.8033C33.6641 30.6082 33.6641 28.6673 32.4453 27.4722L28.625 23.7313V12.75C28.625 11.0595 27.2266 9.6875 25.5 9.6875C23.7734 9.6875 22.375 11.0595 22.375 12.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_819_4828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.f3c06f1a2b116609482a1ec6266d39c8.svg";
export { ForwardRef as ReactComponent };